import React from 'react';
import propTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { info } from './info';
import { InfoTooltip } from 'lib';
import { userTypes } from 'common/permissions';
import styles from './styles';

const useStyles = makeStyles(styles);

const UserTypeInfo = ({ type }) => {
  const classes = useStyles();

  if (!info[type]) return null;

  const content = (
    <>
      {type !== userTypes.admin && <strong>Core Functionality:&nbsp;</strong>}
      <span>{info[type]}</span>
    </>
  );

  return (
    <InfoTooltip
      content={content}
      variant="inline"
      className={classes.icon}
    />
  );
};

UserTypeInfo.propTypes = {
  type: propTypes.string.isRequired,
};

export default UserTypeInfo;
